import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import socket from "../config/Socket";
import { setStatus } from "../Data/features/socket";
// import { logout, socketConntected } from "../Features/DefaultReducer";
// import { updateKey } from "../features/DefaultReducer";

const SocketContext = React.createContext();

export function useSocket() {
  return useContext(SocketContext);
}

export function SocketProvider({ children }) {
  // const api_token = useSelector((state) => state.auth?.user?.api_token);
  const api_token = localStorage.getItem("token");
  const dispatch = useDispatch();

  // console.log(api_token);

  useEffect(() => {
    if (api_token) {
      socket.connectToSocket(
        api_token,
        () => {
          dispatch(setStatus(false)); // callback
        },
        () => {
          dispatch(setStatus(true)); // success
        }
      );
    } else {
      socket?.disconnect();
    }
    return () => socket.disconnect();
  }, [api_token, dispatch]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
}
